import {IErrorResponseItem, ValidationError, ValidationErrors} from "../services/validator";
import { TransactionValidationField } from "./transactions";
import { ITransactionSplit } from "../config/transactions";
import { SplitMethod } from "../components/Transactions/Components/Form/Fields/ShareWithFriends/FriendSelector/FriendSelector";

export type AmountSplitValidation = {
    [key in TransactionValidationField]?: ValidationError[];
};

export type AmountSplitValidationErrors = ValidationErrors<AmountSplitValidation, TransactionValidationField>;

export const amountSplitValidationFactory = (errors: IErrorResponseItem[]): AmountSplitValidationErrors => {
    const v = new ValidationErrors<AmountSplitValidation, TransactionValidationField>();
    v.setMap({
        name: TransactionValidationField.SPLIT_FRIEND_NAME,
        amount: TransactionValidationField.SPLIT_FRIEND_AMOUNT,
    });
    v.setErrors(errors);

    return v;
};

export const validateAmountSplitForm = (data: ITransactionSplit): AmountSplitValidationErrors => {
    const errors = amountSplitValidationFactory([]);

    if (data.name === '') {
        errors.add(TransactionValidationField.SPLIT_FRIEND_NAME, ValidationError.REQUIRED);
    }
    if (data.split_method === SplitMethod.FIXED) {
        if (!data.amount || isNaN(data.amount) || parseFloat(data.amount.toString()) === 0.0) {
            errors.add(TransactionValidationField.SPLIT_FRIEND_AMOUNT, ValidationError.REQUIRED);
        }
    }

    return errors;
};
